import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * On every route change, jump the window to the top.
 * Hash links (e.g. /#contact) still smooth-scroll to the target section
 * via each page's own useEffect, so we only force-top when no hash.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
}
